var LazyResolver_1;
import * as tslib_1 from "tslib";
import { containerResolver } from '../protocol/resolver';
/**
 * Used to allow functions/classes to specify lazy resolution logic.
 */
let LazyResolver = LazyResolver_1 = class LazyResolver {
    /**
     * Creates an instance of the Lazy class.
     * @param key The key to lazily resolve.
     */
    constructor(key) {
        this._key = key;
    }
    /**
     * Creates a Lazy Resolver for the supplied key.
     * @param key The key to lazily resolve.
     * @return Returns an instance of Lazy for the key.
     */
    static of(key) {
        return new LazyResolver_1(key);
    }
    /**
     * Called by the container to lazily resolve the dependency into a lazy locator function.
     * @param container The container to resolve from.
     * @return Returns a function which can be invoked at a later time to obtain the actual dependency.
     */
    get(container) {
        return () => container.get(this._key);
    }
};
LazyResolver = LazyResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Object])
], LazyResolver);
export { LazyResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF6eVJlc29sdmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTGF6eVJlc29sdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBT0EsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFHekQ7O0dBRUc7QUFFSCxJQUFhLFlBQVksb0JBQXpCLE1BQWEsWUFBWTtJQVlyQjs7O09BR0c7SUFDSCxZQUFtQixHQUFXO1FBQzFCLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFqQkQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxFQUFFLENBQUksR0FBVztRQUMzQixPQUFPLElBQUksY0FBWSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2pDLENBQUM7SUFZRDs7OztPQUlHO0lBQ0ksR0FBRyxDQUFDLFNBQW9CO1FBQzNCLE9BQU8sR0FBRyxFQUFFLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztDQUNKLENBQUE7QUE1QlksWUFBWTtJQUR4QixpQkFBaUI7O0dBQ0wsWUFBWSxDQTRCeEI7U0E1QlksWUFBWSJ9